import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MemberPhone from 'components/BusinessLogic/MemberPhone';
import { buildCurrentMemberPhonesSelector } from 'store/selectors/memberPhones.selector';
import { values } from 'lodash';
import Button from 'components/UI/Button';
import Dialog from 'components/UI/Dialog';
import MemberPhoneForm from 'components/BusinessLogic/MemberPhoneForm';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';

function MemberPhones({ className, memberPhones, memberId })
{
    const [loadedMemberPhones, setLoadedMemberPhones] = useState(memberPhones ?? []);
    const [isEditing, setIsEditing] = useState(false);
    const [memberPhoneEditing, setMemberPhoneEditing] = useState(null);

    const openModalEditor = (memberPhoneId) =>
    {
        setMemberPhoneEditing(memberPhoneId);
        setIsEditing(true);
    };

    const updateMemberPhone = (updatedMemberPhone) =>
    {
        if (!loadedMemberPhones.some((mappedMemberPhone) => mappedMemberPhone.id === updatedMemberPhone.id))
        {
            const parseMemberPhones = loadedMemberPhones;
            parseMemberPhones.push(updatedMemberPhone);
            setLoadedMemberPhones(parseMemberPhones);
            return;
        }

        const parseMemberPhones = loadedMemberPhones.map((mappedMemberPhone) => mappedMemberPhone.id === updatedMemberPhone.id ? updatedMemberPhone : mappedMemberPhone);
        setLoadedMemberPhones(parseMemberPhones);
    };

    return memberPhones && memberPhones.length > 0 ? (
        <div className={className}>
            <p className="tw-mb-3 tw-font-bold tw-text-black tw-text-sm dark:tw-text-white">
                Contact Phones
                <Button onClick={() => openModalEditor(null)} margin="tw-mb-2 tw-mt-0 tw-ml-2" iconMargin="tw-mr-1" paddingY="tw-py-0" icon={faPlusCircle}>Add Phone</Button>
            </p>

            <Dialog
                model={{ value: isEditing, setter: setIsEditing }}
            >
                <MemberPhoneForm
                    memberPhoneId={memberPhoneEditing}
                    memberId={memberId}
                    onSuccess={(storedMember) =>
                    {
                        updateMemberPhone(storedMember);
                        setMemberPhoneEditing(null);
                        setIsEditing(false);
                    }}
                    onCancel={() =>
                    {
                        setMemberPhoneEditing(null);
                        setIsEditing(false);
                    }}
                />
            </Dialog>
            {loadedMemberPhones.length > 0 && (
                <div className="tw-flex tw-flex-col tw-gap-2 tw-text-xs tw-overflow-x-auto">
                    <div className="tw-flex tw-px-1">
                        <div className="tw-font-bold tw-text-black dark:tw-text-white">Display Phone</div>
                    </div>
                    {loadedMemberPhones.map((phone) => (
                        <MemberPhone
                            key={phone.id}
                            memberPhoneId={phone.id}
                            handleEdit={() =>
                            {
                                openModalEditor(phone.id);
                            }}
                        />
                    ))}
                </div>
            )}

            {loadedMemberPhones.length === 0
            && (
                <div>
                    No phones have been added so far. Click <button className="tw-text-primary-default hover:tw-underline" type="button" onClick={() => openModalEditor(null)}>here</button> to add one.
                </div>
            )}

        </div>
    ) : null;
}

MemberPhones.defaultProps = {
    className: '',
};

MemberPhones.propTypes = {
    memberPhones: PropTypes.array,
    className: PropTypes.string,
    memberId: PropTypes.number,
};

const mapStateToProps = () =>
{
    const memberPhoneSelector = buildCurrentMemberPhonesSelector();

    return (state, props) => ({
        memberPhones: values(memberPhoneSelector(state, props.memberId)),
    });
};

export default connect(mapStateToProps)(MemberPhones);
